import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";
import { IExplorerProductionOrder } from "../../declarations/IExplorerTypes";

export const getProductionOrdersByItemD365 = async (
    itemNumber: string,
): Promise<IExplorerProductionOrder[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const payload: IReadVerbPayload = { keys: { itemNumber } };
    const response = await axiosAuth.post<IExplorerProductionOrder[]>(
        `/ProductionOrder/GetProductionOrdersByItemD365`,
        payload,
    );
    return response.data;
};

export const useGetProductionOrdersByItemD365 = (itemNumber: string) => {
    return useQuery<IExplorerProductionOrder[]>({
        queryKey: [
            "GetProductionOrdersByItemD365",
            { itemNumber: itemNumber || null },
        ],
        queryFn: () => {
            if (!itemNumber?.trim()) {
                throw new Error(
                    "Invalid params for GetProductionOrdersByItemD365",
                );
            }
            return getProductionOrdersByItemD365(itemNumber);
        },
        enabled: Boolean(itemNumber?.trim()),
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
